import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowRightOutlined } from "@ant-design/icons";
import { TranslationInfoState } from "./translation-info-state.js";
function TranslationInfoStateChange(props) {
    const { stateChange } = props;
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            whiteSpace: "nowrap"
        },
        children: [
            /*#__PURE__*/ _jsx(TranslationInfoState, {
                isComplete: stateChange?.previousComplete
            }),
            /*#__PURE__*/ _jsx(ArrowRightOutlined, {}),
            /*#__PURE__*/ _jsx(TranslationInfoState, {
                isComplete: stateChange?.currentComplete
            })
        ]
    });
}
export { TranslationInfoStateChange };
